<template>
  <div class="app-table-wrapper">
    <v-data-table
      class="app-table v-data-table__without-icons v-datatable-without-pagination"
      v-bind="$attrs"
      v-on="$listeners"
    >
      <template v-for="(_, slot) in $scopedSlots" v-slot:[slot]="scope">
        <slot :name="slot" v-bind="scope" />
      </template>

      <!-- NÃO renomear `plainSlot` para `slot`: o compilador indexa `el.scopedSlots` pela expressão do
           nome dinâmico, então dois v-for escritos `#[slot]` colidem nessa chave e o segundo descarta o
           primeiro EM TEMPO DE COMPILAÇÃO, sumindo com todos os slots COM escopo. Sem erro nem warning.
           v-data-table lê no-data/no-results direto de $slots, não de $scopedSlots. -->
      <template v-for="(_, plainSlot) in $slots" #[plainSlot]>
        <slot :name="plainSlot" />
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: 'AppTable',
}
</script>

<style scoped>
.app-table-wrapper {
  width: 100%;
  overflow-x: auto;
}

.app-table-wrapper ::v-deep .v-data-table__wrapper {
  width: 100%;
}

.app-table-wrapper,
.app-table-wrapper ::v-deep .v-data-table__wrapper {
  scrollbar-width: thin;
  scrollbar-color: color-mix(in srgb, var(--v-primary-base) 40%, transparent) transparent;
}

.app-table-wrapper::-webkit-scrollbar,
.app-table-wrapper ::v-deep .v-data-table__wrapper::-webkit-scrollbar {
  height: 6px;
  width: 6px;
}

.app-table-wrapper::-webkit-scrollbar-track,
.app-table-wrapper ::v-deep .v-data-table__wrapper::-webkit-scrollbar-track {
  background: transparent;
}

.app-table-wrapper::-webkit-scrollbar-thumb,
.app-table-wrapper ::v-deep .v-data-table__wrapper::-webkit-scrollbar-thumb {
  border-radius: 999px;
  background: color-mix(in srgb, var(--v-primary-base) 40%, transparent);
}

.app-table-wrapper::-webkit-scrollbar-thumb:hover,
.app-table-wrapper ::v-deep .v-data-table__wrapper::-webkit-scrollbar-thumb:hover {
  background: var(--v-primary-base);
}

.app-table-wrapper::-webkit-scrollbar-button,
.app-table-wrapper ::v-deep .v-data-table__wrapper::-webkit-scrollbar-button {
  display: none;
  width: 0;
  height: 0;
}

.app-table-wrapper ::v-deep table td,
.app-table-wrapper ::v-deep table th {
  white-space: nowrap;
  max-width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
}

::v-deep .v-data-table tbody tr td {
  padding-top: 10px !important;
  padding-bottom: 10px !important;
}

::v-deep .v-data-table tbody tr:not(:last-child) td {
  border-bottom: 1px solid rgba(0, 0, 0, 0.05) !important;
}
</style>
